import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3200To3299Service {

  constructor() { }
}
